export default class MenuBackground extends PIXI.Container {
    constructor() {
        super();

        this._tweens = new P3.utils.TWEEN.Group();

        this._characters = [];

        this.addCharacter("menu_draw_craig", new PIXI.Point(-270, 310), -Math.PI * 0.1);
        this.addCharacter("menu_draw_gumball", new PIXI.Point(-360, 60), -Math.PI * 0.025);
        this.addCharacter("menu_draw_beast_boy", new PIXI.Point(-480, 320), -Math.PI * 0.05);

        this.addCharacter("menu_draw_jake", new PIXI.Point(30, 340), -Math.PI * 0.01);
        this.addCharacter("menu_draw_jessica", new PIXI.Point(380, 60), Math.PI * 0.05);
        this.addCharacter("menu_draw_grizzly", new PIXI.Point(280, 290), Math.PI * 0.05);

        this.addCharacter("menu_draw_onion", new PIXI.Point(540, 310), -Math.PI * 0.05);
    }

    animateIn() {
        const offset = 120;
        for (let i = 0; i < this._characters.length; i++) {
            const c = this._characters[i];
            const target = c.position.clone();
            //console.log(target);
            const targetRotation = c.rotation;

            c.x += P3.math.randomSign() * offset;
            c.y += offset;

            c.alpha = 0.2;

            c.rotation += Math.sign(c.rotation) * Math.P * 0.05;

            new P3.utils.TWEEN.Tween(c, this._tweens)
                .to({x: target.x, y: target.y, alpha: 1, rotation: targetRotation}, 320)
                .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
                .delay(i * 320)
                .onStart(() => c.visible = true)
                .start();
        }
    }

    update() {
        this._tweens.update();
    }

    addCharacter(key, position, rotation = 0) {
        const sprite = new PIXI.Sprite(P3.assets.texture(key));
        sprite.visible = false;
        sprite.anchor.set(0.5);
        sprite.position = position.clone();
        sprite.rotation = rotation;
        sprite.scale.set(1.1);
        this.addChild(sprite);
        this._characters.push(sprite);
    }
}